import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ProductService } from '../services';
import { productCodeSchema } from '../schemas/product-general-info.schema';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PRODUCTS_LIST_KEY } from '../constants';
import { useNavigate } from 'react-router';

const useProductDuplicateForm = (defaultValues?: any, productId?: string, onClose?: any) => {
  const { t } = useTranslation('product');
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    reset,
    resetField,
    setValue,
    formState,
  } = useForm({
    resolver: yupResolver(productCodeSchema),
    defaultValues,
  });

  const {
    mutate,
    error,
    isPending: isLoading,
    isSuccess,
    data,
  } = useMutation((code: string) => ProductService.cloneProduct(productId as string, code), {
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [PRODUCTS_LIST_KEY] }).then();
      toast.success(t('clone.success'));
      reset();
      onClose?.();
      data?._id && navigate(`/inventory/products/${data?._id as string}/general`);
    },
  });

  return {
    control,
    error,
    isLoading,
    isSuccess,
    data,
    setValue,
    reset,
    resetField,
    onSubmit: handleSubmit((value) => {
      mutate(value);
    }),
    errors: formState?.errors,
  };
};

export default useProductDuplicateForm;
